import { useInfiniteQuery } from "@tanstack/react-query"
import type { InferResponseType } from "hono/client"
import { client } from "@/api"

// GET /admin/teams/:publicId/activity — the team activity log page's data
// source (backend/src/routes/admin/teams/index.ts). Response shape is
// INFERRED from the route rather than redeclared, same as useComposeEmail —
// hand-writing it would silently drop the backend's guarantees (e.g. which
// fields never leave the API).

type ActivityResponse = InferResponseType<
  typeof client.admin.teams[":publicId"]["activity"]["$get"]
>
export type TeamActivityItem = ActivityResponse["activities"][number]
export type TeamActivitySummary = ActivityResponse["team"]

const PAGE_SIZE = 50

export function useTeamActivity(teamPublicId: string) {
  return useInfiniteQuery({
    queryKey: ["admin", "teams", teamPublicId, "activity"],
    initialPageParam: undefined as number | undefined,
    queryFn: async ({ pageParam }) => {
      const res = await client.admin.teams[":publicId"].activity.$get({
        param: { publicId: teamPublicId },
        query: {
          limit: PAGE_SIZE,
          ...(pageParam !== undefined ? { before: pageParam } : {}),
        },
      })
      return res.json() as Promise<ActivityResponse>
    },
    getNextPageParam: (lastPage) => lastPage.next_before ?? undefined,
    enabled: Boolean(teamPublicId),
  })
}
